<section class="facsec2 min" *ngIf="type=='ingreso' || type=='posgrados' || type=='cursos-de-educacion-continua'">
    <div class="container">
        <!--<div class="row">
            <h1 class="title-page" *ngIf="type=='ingreso'">
                Resultados para "Ingreso" con la palabra clave "{{palabra}}"
            </h1>
            <h1 class="title-page" *ngIf="type=='posgrados'">
                Resultados para "Posgrados" con la palabra clave "{{palabra}}"
            </h1>
            <h1 class="title-page" *ngIf="type=='cursos-de-educacion-continua'">
                Resultados para "Cursos de educación continua" con la palabra clave "{{palabra}}"
            </h1>
        </div>-->
        <div class="row" *ngFor="let item of lista">
            <div class="card-border d-flex flex-sm-row flex-column justify-content-between">
                <div class="d-flex flex-column">
                    <h1 class="title" >
                        <a [href]="'/'+language + item.linkCareer">
                            {{item.title}}
                        </a>
                    </h1>

                    <span class="label" *ngIf="item.inicio">
                        <img onerror="this.src='./assets/img/default.png'" class='icon' id="icon-date"
                            src="./assets/img/time-and-calendar.png" alt="">
                        Inicio :
                        <span class="value" >
                            {{item.inicio.date | date:'d/M/yy'}}</span>
                    </span>
                    <span class="label" *ngIf="item.duracion">
                        Duración :
                        <span class="value" >{{item.duracion}}</span>
                    </span>
                    <span class="label" *ngIf="item.modalidad">
                        Modalidad :
                        <span class="value" >{{item.modalidad}}</span>
                    </span>
                </div>
                <div class="container-btn" *ngIf="type=='cursos-de-educacion-continua'">
                    <button class="btn btn-ver" [routerLink]="'/'+language + item.linkCareer">
                        Ver curso
                    </button>
                </div>
                <div class="container-btn" *ngIf="type!='cursos-de-educacion-continua'">
                    <button class="btn btn-ver" [routerLink]="'/'+language + item.linkCareer">
                        Ver carrera
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf=' lista.length == 0 && !spinner ' class='p-3 text-center'>
            <div class="alert alert-primary text-center" role="alert">
                No hay resultados
            </div>
        </div>
    </div>
</section>